export default __webpack_public_path__ + "static/media/kwik_description.f71269fd.png";